var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Calendar")]},proxy:true}])}),_vm._v(" "),_c('Calendar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }